import { InjectionToken } from '@angular/core';

export const StorageServiceToken = new InjectionToken<IStorageService>(
  'StorageService',
);

export interface IStorageService {
  getItem(key: string): string | null;
  setItem(key: string, value: string): void;
  removeItem(key: string): void;
}
